import { useEffect, useRef } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import "@/App.css";

import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Problem } from "@/components/landing/Problem";
import { Pillars } from "@/components/landing/Pillars";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Trust } from "@/components/landing/Trust";
import { DataSources } from "@/components/landing/DataSources";
import { SampleReport } from "@/components/landing/SampleReport";
import { ReportsGallery } from "@/components/landing/ReportsGallery";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { WhoItsFor } from "@/components/landing/WhoItsFor";
import { Audiences } from "@/components/landing/Audiences";
import { Positioning } from "@/components/landing/Positioning";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

function App() {
  const lenisRef = useRef(null);

  const scrollTo = (id) => {
    const lenis = lenisRef.current?.lenis;
    if (id === "top") {
      if (lenis) lenis.scrollTo(0, { duration: 1.2 });
      else window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) {
      lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    // ensure body has grain overlay
    document.body.classList.add("grain");
    return () => document.body.classList.remove("grain");
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }} ref={lenisRef}>
      <div className="App bg-paper text-ink min-h-screen">
        <Nav onScrollTo={scrollTo} />
        <main>
          <Hero onScrollTo={scrollTo} />
          <Problem />
          <Pillars />
          <HowItWorks />
          <Trust />
          <DataSources />
          <SampleReport />
          <ReportsGallery />
          <EditorialMarquee />
          <WhoItsFor />
          <Audiences />
          <Positioning />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#123A33",
              color: "#F7F4EC",
              border: "1px solid #123A33",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
